var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.selectedProject.styleGuideLink,"target":"_blank"}},[_vm._v("Go to style guide")])
}
var staticRenderFns = []

export { render, staticRenderFns }